import { render, staticRenderFns } from "./input-aspect-cthulhu.vue?vue&type=template&id=3aa3d80e&scoped=true&"
import script from "./input-aspect-cthulhu.vue?vue&type=script&lang=js&"
export * from "./input-aspect-cthulhu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3d80e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa3d80e')) {
      api.createRecord('3aa3d80e', component.options)
    } else {
      api.reload('3aa3d80e', component.options)
    }
    module.hot.accept("./input-aspect-cthulhu.vue?vue&type=template&id=3aa3d80e&scoped=true&", function () {
      api.rerender('3aa3d80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input-aspect-cthulhu.vue"
export default component.exports